import * as React from 'react';

const SvgComponent = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 390 390"
    style={{
      enableBackground: 'new 0 0 390 390'
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="M331.8 71.3C331.8 37.9 270.5 20 195 20S58.3 37.9 58.2 71.3l-7.9 151.3v94.7c0 5.8 4.7 10.5 10.5 10.5H70v26.3c0 8.7 7.1 15.8 15.8 15.8h10.5c8.7 0 15.8-7.1 15.8-15.8v-26.3h165.8v26.3c0 8.7 7.1 15.8 15.8 15.8h10.5c8.7 0 15.8-7.1 15.8-15.8v-26.3h9.2c5.8 0 10.5-4.7 10.5-10.5v-94.7l-7.9-151.3zM147 41.1h96c5.1 0 9.2 4.1 9.2 9.2s-4.1 9.2-9.2 9.2h-96c-5.1 0-9.2-4.1-9.2-9.2s4-9.2 9.2-9.2zM91.1 283.2c-10.9 0-19.7-8.8-19.7-19.7s8.8-19.7 19.7-19.7 19.7 8.8 19.7 19.7-8.8 19.7-19.7 19.7zm207.8 0c-10.9 0-19.7-8.8-19.7-19.7s8.8-19.7 19.7-19.7c10.9 0 19.7 8.8 19.7 19.7s-8.7 19.7-19.7 19.7zm8.6-60.6h-225c-6.8 0-12.2-5.7-11.8-12.5l6.4-122.2c.3-5.7 4.9-10 10.5-10h213.6c6.3 0 11.4 4.9 11.8 11.2l6.3 121.1c.4 6.8-5 12.4-11.8 12.4z" />
  </svg>
);

export default SvgComponent;
